import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
/**
 * Plain wrapper around the item
 */
export function AttributeContainer(props) {
    return _jsx(Box, { className: "attribute-container", children: props.children });
}
//# sourceMappingURL=AttributeContainer.js.map